import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Grid, Radio, TextField } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import CancelIcon from "@mui/icons-material/Close";
import "./style.css";
import { useState, useEffect } from "react";
import { addProcessingPackagingPlantsDiff } from "../../../Redux/Actions/InputData";
import { addSourceBePartOfOptimization } from "../../../Redux/Actions/InputData";
import { addPackingPlantAddMinorIngredient } from "../../../Redux/Actions/InputData";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertProps } from "@mui/material/Alert";
import { useSelector, useDispatch } from "react-redux";
import { TramRounded } from "@mui/icons-material";

const BootstrapDialog = styled(Dialog)(({ theme }: any) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function InputCapacityModal(props: any) {
  console.log(props, "inputcapacity modal props");
  // localStorage.clear();
  // const {
  //   getIsProcessingPackagingPlantsDiff,
  //   getIsSourceBePartOfOptimization,
  //   getIsPackingPlantAddMinorIngredient,
  // } = props;
  const [processingPlantsCount, setProcessingPlantsCount] = useState<any>(0);
  const [packagingPlantsCount, setPackagingPlantsCount] = useState<any>(0);
  const [plantClosure, setPlantClosure] = useState(false);
  const getIsProcessingPackagingPlantsDiff = useSelector(
    (state: any) => state.InputDataReducers.isProcessingPackagingPlantsDiff
  );

  const getIsSourceBePartOfOptimization = useSelector(
    (state: any) => state.InputDataReducers.isSourceBePartOfOptimization
  );

  const getIsPackingPlantAddMinorIngredient = useSelector(
    (state: any) => state.InputDataReducers.isPackingPlantAddMinorIngredient
  );

  const [isProcessingPackagingPlantsDiff, setProcessingPackagingPlantsDiff] =
    useState<any>(getIsProcessingPackagingPlantsDiff);
  const [isSourceBePartOfOptimization, setSourceBePartOfOptimization] =
    useState<any>(getIsSourceBePartOfOptimization);
  const [isPackingPlantAddMinorIngredient, setPackingPlantAddMinorIngredient] =
    useState<any>(getIsPackingPlantAddMinorIngredient);
  const dispatch: any = useDispatch();

  const handleChangeSelectLine = (e: any, index: number) => {
    e.preventDefault();
    localStorage.setItem("selectedUsecase", "Long Term Analysis");

    const setValues = JSON.parse(e.target.value);
    if (index == 0) {
      setProcessingPackagingPlantsDiff(setValues);
      dispatch(addProcessingPackagingPlantsDiff(setValues));
      dispatch(addSourceBePartOfOptimization(true));
      if (setValues == false) {
        setPackingPlantAddMinorIngredient(false);
        dispatch(addPackingPlantAddMinorIngredient(false));
        setPackagingPlantsCount(0);
        setProcessingPlantsCount(0);
      }
      if (plantClosure) {
        setPlantClosure(false);
        setPackagingPlantsCount(0);
        setProcessingPlantsCount(0);
      }
    } else if (index == 1) {
      setSourceBePartOfOptimization(setValues);
      dispatch(addSourceBePartOfOptimization(setValues));
      if (plantClosure) {
        setPlantClosure(false);
        setPackagingPlantsCount(0);
        setProcessingPlantsCount(0);
      }
    } else if (index == 2) {
      setPackingPlantAddMinorIngredient(setValues);
      dispatch(addPackingPlantAddMinorIngredient(setValues));
    }
  };

  const handleOpenNextFlow = () => {
    console.log("handleOpenNextFlow");
    props.handleNext({
      isProcessing: isProcessingPackagingPlantsDiff,
      isSourcing: isSourceBePartOfOptimization,
      isGradient: isPackingPlantAddMinorIngredient,
      isClosure: plantClosure,
      countofProcessingPlants: processingPlantsCount,
      countofPackagingPlants: packagingPlantsCount,
    });
  };

  const handleOpenNextFolderModule = () => {
    if (
      isProcessingPackagingPlantsDiff &&
      isSourceBePartOfOptimization &&
      isPackingPlantAddMinorIngredient
    ) {
      handleOpenNextFlow();
    } else if (
      isProcessingPackagingPlantsDiff &&
      isSourceBePartOfOptimization &&
      !isPackingPlantAddMinorIngredient
    ) {
      handleOpenNextFlow();
    } else if (
      isProcessingPackagingPlantsDiff &&
      !isSourceBePartOfOptimization &&
      isPackingPlantAddMinorIngredient
    ) {
      handleOpenNextFlow();
    } else if (
      isProcessingPackagingPlantsDiff &&
      !isSourceBePartOfOptimization &&
      !isPackingPlantAddMinorIngredient
    ) {
      handleOpenNextFlow();
    } else if (
      !isProcessingPackagingPlantsDiff &&
      isSourceBePartOfOptimization &&
      !isPackingPlantAddMinorIngredient
    ) {
      handleOpenNextFlow();
    } else if (
      !isProcessingPackagingPlantsDiff &&
      !isSourceBePartOfOptimization &&
      !isPackingPlantAddMinorIngredient
    ) {
      handleOpenNextFlow();
    } else {
      setSnackbar({
        children:
          "Please try to give a valid senarios from the selected radios",
        severity: "error",
      });
    }
  };

  const [snackbar, setSnackbar] = useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleCloseSnackbar = () => setSnackbar(null);

  const handleCheckEvaluate = (e: any) => {
    setPlantClosure(e.target.checked);
    if (!e.target.checked) {
      setPackagingPlantsCount(0);
      setProcessingPlantsCount(0);
    }
  };
  useEffect(() => {
    if (props.selectFolder) {
      const moduleName = props.selectFolder.slice(0, 7);
      console.log(moduleName, "moduleNamemoduleName");
      if (moduleName === "module1") {
        setProcessingPackagingPlantsDiff(true);
        dispatch(addProcessingPackagingPlantsDiff(true));
        setSourceBePartOfOptimization(true);
        dispatch(addSourceBePartOfOptimization(true));
        setPackingPlantAddMinorIngredient(true);
        dispatch(addPackingPlantAddMinorIngredient(true));
      } else if (moduleName === "module2") {
        setProcessingPackagingPlantsDiff(true);
        setSourceBePartOfOptimization(false);
        setPackingPlantAddMinorIngredient(true);
        dispatch(addProcessingPackagingPlantsDiff(true));
        dispatch(addSourceBePartOfOptimization(false));
        dispatch(addPackingPlantAddMinorIngredient(true));
      } else if (moduleName === "module3") {
        setProcessingPackagingPlantsDiff(false);
        setSourceBePartOfOptimization(true);
        setPackingPlantAddMinorIngredient(false);
        dispatch(addProcessingPackagingPlantsDiff(false));
        dispatch(addSourceBePartOfOptimization(true));
        dispatch(addPackingPlantAddMinorIngredient(false));
      } else if (moduleName === "module4") {
        setProcessingPackagingPlantsDiff(false);
        setSourceBePartOfOptimization(false);
        setPackingPlantAddMinorIngredient(false);
        dispatch(addProcessingPackagingPlantsDiff(false));
        dispatch(addSourceBePartOfOptimization(false));
        dispatch(addPackingPlantAddMinorIngredient(false));
      } else if (moduleName === "module5") {
        setProcessingPackagingPlantsDiff(true);
        setSourceBePartOfOptimization(true);
        setPackingPlantAddMinorIngredient(false);
        dispatch(addProcessingPackagingPlantsDiff(true));
        dispatch(addSourceBePartOfOptimization(true));
        dispatch(addPackingPlantAddMinorIngredient(false));
      } else if (moduleName === "module6") {
        setProcessingPackagingPlantsDiff(true);
        setSourceBePartOfOptimization(false);
        setPackingPlantAddMinorIngredient(false);
        dispatch(addProcessingPackagingPlantsDiff(true));
        dispatch(addSourceBePartOfOptimization(false));
        dispatch(addPackingPlantAddMinorIngredient(false));
      }
    }
  }, []);

  return (
    <div>
      <BootstrapDialog
        onClose={props.onClose}
        aria-labelledby="customized-dialog-title"
        open={props.isOpen}
      >
        <div className="modal-header nakshatra-modal">
          <Grid container spacing={1}>
            <Grid item xs={10} md={10} lg={10}>
              <h3>Nakshatra</h3>
              <div className="sub-text">
                Add below inputs to customise the profile
              </div>
            </Grid>
            <Grid item xs={2} md={2} lg={2}>
              <CancelIcon className="cancel-icon" onClick={props.onClose} />
            </Grid>
          </Grid>
        </div>
        <>
          <DialogContent className="modal-body">
            <div>
              <br></br>
              <table
                width={"100%"}
                className="nakshatra-table"
                cellPadding={0}
                cellSpacing={0}
              >
                <tr>
                  <td>1. Are the processing and packaging plants different?</td>
                  <td>
                    <div>
                      <span>
                        <Radio
                          checked={isProcessingPackagingPlantsDiff === true}
                          onChange={(e) => handleChangeSelectLine(e, 0)}
                          value={true}
                          name="radio-buttons"
                          inputProps={{ "aria-label": "yes" }}
                          disabled={props.selectRadio !== "masterData"}
                        />
                      </span>
                      <label>Yes</label>
                      <span>
                        <Radio
                          checked={isProcessingPackagingPlantsDiff === false}
                          onChange={(e) => handleChangeSelectLine(e, 0)}
                          value={false}
                          name="radio-buttons"
                          inputProps={{ "aria-label": "no" }}
                          disabled={props.selectRadio !== "masterData"}
                        />
                      </span>
                      <label>No</label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>2. Should sourcing be a part of optimization?</td>
                  <td>
                    {" "}
                    <div>
                      <span>
                        <Radio
                          checked={isSourceBePartOfOptimization === true}
                          onChange={(e) => handleChangeSelectLine(e, 1)}
                          value={true}
                          name="radio-buttons"
                          inputProps={{ "aria-label": "yes" }}
                          disabled={props.selectRadio !== "masterData"}
                        />
                      </span>
                      <label>Yes</label>
                      <span>
                        <Radio
                          checked={isSourceBePartOfOptimization === false}
                          onChange={(e) => handleChangeSelectLine(e, 1)}
                          value={false}
                          name="radio-buttons"
                          inputProps={{ "aria-label": "no" }}
                          disabled={props.selectRadio !== "masterData"}
                        />
                      </span>
                      <label>No</label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>3. Does the packaging plant add minor ingredient?</td>
                  <td>
                    <div>
                      <span>
                        <Radio
                          checked={isPackingPlantAddMinorIngredient === true}
                          onChange={(e) => handleChangeSelectLine(e, 2)}
                          value={true}
                          name="radio-buttons"
                          inputProps={{ "aria-label": "yes" }}
                          disabled={
                            !isProcessingPackagingPlantsDiff ||
                            props.selectRadio !== "masterData"
                          }
                        />
                      </span>
                      <label>Yes</label>
                      <span>
                        <Radio
                          checked={isPackingPlantAddMinorIngredient === false}
                          onChange={(e) => handleChangeSelectLine(e, 2)}
                          value={false}
                          name="radio-buttons"
                          inputProps={{ "aria-label": "no" }}
                          disabled={
                            !isProcessingPackagingPlantsDiff ||
                            props.selectRadio !== "masterData"
                          }
                        />
                      </span>
                      <label>No</label>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
            <br></br>
            <div className="nakshatra-closure">
              <div>
                <h3>Consider closure of capacity?</h3>
              </div>
              <div
                className={
                  props.selectRadio === "inputData"
                    ? "input-check-selected"
                    : "input-check"
                  // ? "input"
                  // : "checked"
                }
              >
                <table>
                  <tr>
                    <td colSpan={2}>
                      <input
                        type="checkbox"
                        onChange={(e) => handleCheckEvaluate(e)}
                        checked={plantClosure}
                        // disabled={!plantClosure}
                      />
                      <b> Evaluate plant closure</b>
                    </td>
                  </tr>
                  <tr>
                    <td width="300px">
                      <span>Count of Processing Plants</span>
                    </td>
                    <td>
                      <TextField
                        onChange={(e) =>
                          setProcessingPlantsCount(
                            e.target.value.replace(/[^0-9]/g, "")
                          )
                        }
                        value={processingPlantsCount}
                        disabled={!plantClosure}
                        type="number"
                      />
                    </td>
                  </tr>
                  {isProcessingPackagingPlantsDiff && (
                    <tr>
                      <td width="300px">
                        <span>Count of Packaging Plants</span>
                      </td>
                      <td>
                        <TextField
                          onChange={(e) =>
                            setPackagingPlantsCount(
                              e.target.value.replace(/[^0-9]/g, "")
                            )
                          }
                          value={packagingPlantsCount}
                          disabled={!plantClosure}
                          type="number"
                        />
                      </td>
                    </tr>
                  )}
                </table>
              </div>
            </div>
          </DialogContent>

          <DialogActions>
            <div className="modal-action">
              {!props.hideGoBackBtnICModalForLT && (
                <Button
                  variant="outlined"
                  className="cancel"
                  onClick={props.handleGoBack}
                >
                  Go back
                </Button>
              )}

              <Button
                variant="contained"
                className={
                  processingPlantsCount !== "" && packagingPlantsCount !== ""
                    ? "Next"
                    : !isProcessingPackagingPlantsDiff &&
                      plantClosure &&
                      processingPlantsCount
                    ? "Next"
                    : "disabled-proc-btn"
                }
                onClick={handleOpenNextFolderModule}
              >
                Proceed
              </Button>
            </div>
          </DialogActions>
        </>
      </BootstrapDialog>
      {!!snackbar && (
        <Snackbar
          open
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={handleCloseSnackbar}
          autoHideDuration={6000}
        >
          <Alert {...snackbar} onClose={handleCloseSnackbar} />
        </Snackbar>
      )}
    </div>
  );
}
export default InputCapacityModal;
